import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import AccountFormContainer from 'src/app/containers/Registration/Account/AccountFormContainer';
import RegulationsContact from 'src/app/components/RegulationsContact';
import LayoutRightColumn from 'src/app/components/Layout/LayoutRightColumn';
import Layout from 'src/app/components/Layout/Layout';
import LayoutLeftColumn from 'src/app/components/Layout/LayoutLeftColumn';
import background from 'src/assets/images/background-registration.jpg';
import 'src/app/containers/Registration/Account/AccountComponent.scss';


const AccountComponent = ({ location }) => (
  <Layout>
    <LayoutLeftColumn>

      <AccountFormContainer/>

      <p styleName="login-redirection">
        Masz konto? <Link
          to={ { pathname: '/', search: location.search } }
          styleName="login-redirection__link"
          title="Zaloguj się"
        >
          Zaloguj się
        </Link>
      </p>

      <RegulationsContact/>

    </LayoutLeftColumn>

    <LayoutRightColumn background={ background }>
      <h1 styleName="welcome__headline">Jesteś o krok od lepszej pracy</h1>
      <h3 styleName="welcome__subline">Załóż konto i sprawdź, czy nie szukasz</h3>
    </LayoutRightColumn>

  </Layout>
);

AccountComponent.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired
  }).isRequired
};

export default withRouter(AccountComponent);
